import React from "react";
import { useNavigate } from "react-router-dom";
import inConstructionImg from "../../assets/inConstruction.webp";
import DownloadIcon from "../../assets/download.svg";
import "./Blog.css";

export default function Blog() {
    const navigate = useNavigate();
    return (
        <>
            <title>The Oakmate Blog | Chess Strategy, Tips, and Updates</title>
            <meta
                name="description"
                content="Explore articles on chess improvement, strategy, opening theory, and the latest updates from the Oakmate team."
            />
            <div className="blog">
                <img
                    src={inConstructionImg}
                    alt="In Construction"
                    className="inConstructionImg"
                />
                <div className="inConstruction-title">
                    We're still cooking this up!
                </div>
                <div className="inConstruction-subtitle">
                    In the meantime, check out our Chrome extension — it works
                    right on chess.com.
                </div>
                <button
                    className="download-cta"
                    onClick={() => {
                        navigate("/download");
                    }}
                >
                    <div className="download-cta-text">Download</div>
                    <img
                        src={DownloadIcon}
                        className="download-cta-icon"
                        alt="Download Icon"
                    />
                </button>
                <button className="back-to-home" onClick={() => navigate("/")}>
                    Back to home page
                </button>
            </div>
        </>
    );
}
